// CustomFieldsPage.jsx — CONTAINER das perguntas do agendamento. Estado e chamadas moram em useCustomFieldsScreen;
// o visual é da CustomFieldsView (View pura do Claude Design, docs/DESIGN-FLOW.md).
import AppSnackbar from '../components/ui/AppSnackbar';
import ConfirmDialog from '../components/ui/ConfirmDialog';
import CustomFieldsView from './customFields/CustomFieldsView';
import { useCustomFieldsScreen } from './customFields/useCustomFieldsScreen';

export default function CustomFieldsPage() {
  const { vm, actions, snackbar, hideSnackbar, stopBasic, onConfirmStopBasic, onCancelStopBasic } = useCustomFieldsScreen();

  return (
    <>
      <CustomFieldsView vm={vm} actions={actions} />

      <ConfirmDialog
        open={!!stopBasic}
        onClose={onCancelStopBasic}
        onConfirm={onConfirmStopBasic}
        title={stopBasic?.title}
        message={stopBasic?.message}
        confirmText={stopBasic?.confirmLabel}
      />

      <AppSnackbar snackbar={snackbar} onClose={hideSnackbar} />
    </>
  );
}
